export type Config = {
  configID: number;
  configKey: string;
  configValue: string;
  uom: string;
};

export type ConfigState = {
  data: Config[];
  loading: boolean;
  error: string | null;
};

export const initialState: ConfigState = {
  data: [],
  loading: false,
  error: null,
};
export type ConfigServiceOperators = {
  configuration: Config[];
  fetchAllConfiguration: () => void;
};
